import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import * as uiLibrary from '@tolk-ai/ui-library-react';
import * as genericUtils from '@tolk-ai/generic-utils';

const Component$3 = ({
  channelDetail
}) => jsx(uiLibrary.highcharts.Component, {
  options: {
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: false
        }
      }
    },
    series: [{
      data: channelDetail.detailCount.map(detail => [new Date(detail.date).getTime(), detail.count]),
      name: 'Conversations',
      type: 'column'
    }],
    title: {
      text: undefined
    },
    xAxis: {
      labels: {
        format: '{value:%d. %b}'
      },
      type: 'datetime'
    },
    yAxis: {
      title: {
        text: 'Conversations'
      }
    }
  }
}, void 0);

const Component$2 = ({
  startDate,
  endDate
}) => jsx(uiLibrary.highcharts.Component, {
  options: {
    credits: {
      enabled: false
    },
    lang: {
      noData: `No data available for the given period ${startDate} - ${endDate}`
    },
    legend: {
      enabled: false
    },
    noData: {
      position: {
        align: 'center',
        verticalAlign: 'middle',
        x: 0,
        y: 0
      },
      style: {
        fontSize: '16px',
        fontWeight: 'normal'
      }
    },
    series: [{
      name: 'Conversations count',
      type: 'column'
    }],
    title: {
      text: undefined
    },
    yAxis: {
      title: {
        text: 'Conversations'
      }
    }
  }
}, void 0);

const Component$1 = () => jsx(uiLibrary.highcharts.Component, {
  options: {
    credits: {
      enabled: false
    },
    lang: {
      noData: 'An error occured, please retry'
    },
    legend: {
      enabled: false
    },
    noData: {
      position: {
        align: 'center',
        verticalAlign: 'middle',
        x: 0,
        y: 0
      },
      style: {
        fontSize: '16px'
      }
    },
    series: [{
      name: 'Conversations count',
      type: 'column'
    }],
    title: {
      text: undefined
    },
    yAxis: {
      title: {
        text: 'Conversations'
      }
    }
  }
}, void 0);

const Component = () => jsx(uiLibrary.highcharts.Component, {
  options: {
    credits: {
      enabled: false
    },
    lang: {
      noData: `Loading datas, please wait`
    },
    legend: {
      enabled: false
    },
    noData: {
      position: {
        align: 'center',
        verticalAlign: 'middle',
        x: 0,
        y: 0
      },
      style: {
        fontSize: '16px',
        fontWeight: 'normal'
      }
    },
    series: [{
      name: 'Conversations count',
      type: 'column'
    }],
    title: {
      text: undefined
    },
    yAxis: {
      title: {
        text: 'Conversations'
      }
    }
  }
}, void 0);

const convertDateToFormattedDate = date => {
  return date.toISOString();
};

const onInit = async (channelId, endDate, getOneChannelDetailConversationsCount, setState, startDate) => {
  try {
    const result = await getOneChannelDetailConversationsCount(startDate, endDate, channelId);

    if (result.totalCount === genericUtils.NUMBER.DEFAULT_CONVERSATION) {
      setState({
        data: {
          endDate: convertDateToFormattedDate(result.endDate),
          startDate: convertDateToFormattedDate(result.startDate)
        },
        type: 'emptyData'
      });
      return;
    }

    const newDetailCount = result.detailCount.map(detail => {
      return Object.assign(Object.assign({}, detail), {
        date: convertDateToFormattedDate(detail.date)
      });
    });
    setState({
      data: Object.assign(Object.assign({}, result), {
        detailCount: newDetailCount
      }),
      type: 'data'
    });
  } catch (_a) {
    setState({
      type: 'error'
    });
  }
};

const container = getOneChannelDetailConversationsCount => ({
  channelId,
  endDate,
  startDate
}) => {
  const [state, setState] = React.useState({
    type: 'loading'
  });
  React.useEffect(() => {
    setState({
      type: 'loading'
    });
    void onInit(channelId, endDate, getOneChannelDetailConversationsCount, setState, startDate);
  }, [channelId, endDate, startDate]);
  return jsxs("div", {
    children: [state.type === 'data' && jsx(Component$3, {
      channelDetail: state.data
    }, void 0), state.type === 'emptyData' && jsx(Component$2, {
      endDate: state.data.endDate,
      startDate: state.data.startDate
    }, void 0), state.type === 'loading' && jsx(Component, {}, void 0), state.type === 'error' && jsx(Component$1, {}, void 0)]
  }, void 0);
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container
});

export { index as channelDetailConversation };
